/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react'
import EverlaneLink from '@everlane/link'
import useGeolocation from 'lib/network/hooks/useGeolocation'
import { getDistanceFromUser } from 'lib/helpers/localization'
import importEverlaneIcon, { Icon } from 'lib/iconProps'
import SlideDownUp from 'lib/animations/SlideDownUp'
import styles from './styles.module.scss'

const Plus = importEverlaneIcon(Icon.PLUS)
const Minus = importEverlaneIcon(Icon.MINUS)

const formatDistance = ({ latitude, longitude, visitorLatLong }) => {
  const distanceFromUser = getDistanceFromUser({
    latitude,
    longitude,
    visitorLatLong,
  })
  const rounding = distanceFromUser > 10 ? 0 : 1

  if (distanceFromUser > 55) return null

  return `${distanceFromUser.toFixed(rounding)} mi`
}

const formatHours = hours => {
  return hours.split('\n').map(hour => {
    const index = hour.search(/\d/)
    const time = hour.slice(index)
    const days = hour.slice(0, index)
    return [days, time]
  })
}

const Time = ({ time }) => {
  const [days, hours] = time

  return (
    <time className={styles.store__time}>
      {days} {hours}
    </time>
  )
}

const Event = ({ event, index }) => {
  const { title, description, hours, url, ctaText } = event
  const [eventOpenIndex, setEventOpenIndex] = useState(null)

  const handleClick = () => {
    if (eventOpenIndex === index) {
      return setEventOpenIndex(null)
    }

    return setEventOpenIndex(index)
  }

  return (
    <div>
      <button className={styles.store_button} onClick={handleClick} type="button">
        <h4 className={styles['store__section-title']}>{title}</h4>
        <div className={styles['event__section-expand']}>
          {eventOpenIndex === index ? (
            <Minus width={20} height="4em" />
          ) : (
            <Plus width={20} height="4em" />
          )}
        </div>
      </button>

      <SlideDownUp
        appear
        shouldShow={eventOpenIndex === index}
        className={styles['footer-links__link__container']}
      >
        <p className={styles.event__description}>{description}</p>
        {hours.length > 0 && formatHours(hours)?.map((h, i) => <Time time={h} key={`event${i}`} />)}
        <EverlaneLink
          href={url}
          target="_blank"
          className={styles.event__cta}
          chevron
          underlinedInlineWhite
        >
          {ctaText}
        </EverlaneLink>
      </SlideDownUp>
    </div>
  )
}

const StoreDetails = ({
  streetAddress,
  city,
  regionCode,
  postalCode,
  displayName,
  hours,
  phone,
  storefrontEvents,
  latitude,
  longitude,
}) => {
  const mapLink = `https://www.google.com/maps/place/${encodeURIComponent(
    streetAddress,
  )},+${encodeURIComponent(city)},+${encodeURIComponent(regionCode)},+${encodeURIComponent(
    postalCode,
  )}`

  const { data: geolocation } = useGeolocation()
  const { latLong: visitorLatLong } = geolocation || {}

  return (
    <section className={styles.store__container}>
      <div className={styles.store_heading}>
        <div>
          <h2 className={styles.store__name}>{displayName}</h2>
          <h4 className={styles['store__city-name']}>{city}</h4>
        </div>
        <p className={styles.store_distance}>
          {formatDistance({ latitude, longitude, visitorLatLong })}
        </p>
      </div>

      <div className={styles.store__section}>
        <h3 className={styles['store__section-title']}>Hours</h3>
        {hours.length > 0 && formatHours(hours)?.map((h, i) => <Time time={h} key={`time${i}`} />)}
      </div>

      <address className={styles.store__section}>
        <h3 className={styles['store__section-title']}>Address</h3>
        {streetAddress}
        <br />
        {city}, {regionCode} {postalCode}
        <br />
        <div>{phone}</div>
        <a href={mapLink} target="_blank" rel="noreferrer">
          Get Directions
        </a>
      </address>

      <div className={styles.store__events}>
        {storefrontEvents?.length > 0 &&
          storefrontEvents.map((event, index) => (
            <Event key={event.title} event={event} index={index} />
          ))}
      </div>
    </section>
  )
}

export default StoreDetails
